module.exports = __webpack_public_path__ + "img/esmeralda-hotel-3.5131c9d8.jpg";